import StringValidator from "./StringValidator"
import { ComponentType } from "svelte/types/runtime/internal/dev"
import CollectionTimes from "../Helpers/CollectionTimes/CollectionTimes.svelte"

export default class CollectionTimesValidator extends StringValidator {
    public readonly inputHelper: ComponentType = CollectionTimes
    constructor() {
        super(
            "points_in_time",
            "'Points in time' are points according to a fixed schedule, e.g. 'every monday at 10:00'. They are typically used for postbox collection times or times of mass at a place of worship"
        )
    }
}
